export default "__VITE_ASSET__5c5933d8__"